// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__TXGEZ","image":"Avatar_image__oIoxG","fallback":"Avatar_fallback__Hkvuo","avatarSkeletonShimmer":"Avatar_avatarSkeletonShimmer__RPdJu"};